module.exports = __webpack_public_path__ + "img/contact_header.5b32dfcc.png";